import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    q: "How do salons and spas get more bookings in Colorado?",
    a: "Local SEO + reviews + a frictionless online booking flow. 'Hair salon near me', 'lash extensions', 'facial Colorado Springs' all convert when you rank in the Map Pack and offer instant booking. Salons relying on walk-ins lose to competitors who own search.",
  },
  {
    q: "Should I build pages for each service?",
    a: "Yes. Color, balayage, extensions, lashes, facials, massage, waxing all have separate search intent. Per-service pages multiply rankings and bookings vs. one generic 'services' page.",
  },
  {
    q: "Is Google Ads worth it for salons?",
    a: "Seasonally yes — holiday gifting (Nov–Dec), wedding season (May–Aug), and back-to-school (Aug). Outside those, lean on SEO, Instagram, and rebooking automation.",
  },
  {
    q: "How important are reviews for a salon or med spa?",
    a: "Critical. Salons are review-driven businesses — 4.8+ stars with 100+ reviews is the threshold for premium pricing. We build review-request automation into the post-service flow.",
  },
  {
    q: "Do you handle marketing for individual stylists too?",
    a: "Yes — booth renters and independent stylists benefit from personal-brand sites and Instagram funnels even more than full salons. We build hybrid setups that promote the studio and the individual.",
  },
];

export const Route = createFileRoute("/salon-spa-marketing-colorado")({
  head: () =>
    industryMarketingHead("Salon & Spa", "salon or spa", "salon-spa-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry="Salon & Spa"
      industryLower="salon or spa"
      slug="salon-spa-marketing-colorado"
      subheadline="We help Colorado salons, spas, and individual stylists fill the chair through local SEO, reviews, and frictionless online booking — not walk-ins and hope."
      painPoints={[
        "Walk-ins dropped and rebookings don't fill the gap",
        "Your Instagram is beautiful but bookings still come from one or two stylists",
        "Med spa and lash services are buried under the same 'services' page and rank for nothing",
      ]}
      serviceDescriptions={{
        seo: "Rank for hair, color, lashes, facials, massage, waxing, and every service — across every Colorado market.",
        googleMaps: "Own the Map Pack with a 4.8+ profile so 'salon near me' searches see you first.",
        webDesign: "Booking-first salon sites with instant scheduling, stylist pages, and service-specific landing pages.",
        ppc: "Seasonal Google Ads for holiday gifting, wedding season, and back-to-school surges.",
        geoAi: "Get cited when buyers ask ChatGPT 'best hair salon in Colorado Springs' or 'med spa near me'.",
        socialMedia: "Instagram-to-booking flows and review automation that compound your reputation.",
      }}
      testimonial={{
        quote:
          "Online bookings tripled in 90 days. The instant-booking flow and per-service pages did the heavy lifting.",
        role: "Salon Owner",
        city: "Colorado Springs",
      }}
      faqs={FAQS}
      cityHubLinks={[
        { to: "/colorado-springs", label: "Salon & spa marketing in Colorado Springs", description: "Fill the chair across Briargate, downtown, and southern Colorado Springs." },
        { to: "/denver-digital-marketing", label: "Salon & spa marketing in Denver", description: "Compete in Denver's premium beauty and wellness market." },
        { to: "/castle-rock-digital-marketing", label: "Salon & spa marketing in Castle Rock", description: "Premium salon, lash, and med spa services across Douglas County." },
      ]}
    />
  ),
});
